import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Main } from '../core/main.service';

@Injectable({
    providedIn: 'root'
})
export class MiscService {
    constructor(private httpClient: HttpClient, private mainService: Main, @Inject(Restangular) public Restangular: any) {
    }

    getBranches(options: string) {
        debugger;
        return this.Restangular.one('branches?' + options).customGET('');
    }

    getAllBranches(options: string = null) {
        debugger;
        return this.Restangular.one('branches?all=true' + options).customGET('');
    }

    getBranchMembers(id: String) {
        debugger;
        return this.Restangular.one('branches/' + id + '/members').customGET('');
    }

    getBranch(id: string) {
        return this.Restangular.one('branches/' + id).customGET('');
    }

    createBranch(branch: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('branches/' + id).customPUT(branch);
        }
        return this.Restangular.one('branches').customPOST(branch);
    }

    changeBranchStatus(id: string, status: string) {
        return this.Restangular.one(`branches/${id}/${status}`).customPUT('');
    }

}
